import React from "react";
import "./PageAboutLogoUsage.css";

export default class PageAboutLogoUsage extends React.Component {
	constructor(props) {
		super(props);

		this.state = {};
	}

	// eslint-disable-next-line class-methods-use-this
	render() {
		return (
			<div id="PageAboutLogoUsage">
				<div className="resume-section-content">
					<h6>Minimum size</h6>
					<div className="row">
						<div className="col-md-6 offset-md-3">
							<div className="featurette-image img-fluide mx-auto">
								<img src="/img/chart/minimum-size.png" width="400px" alt="Responsive image"/>
							</div>
						</div>
						<div className="col-md-12">
							<p>The logo must be clearly visible across all the communications. To make sure it
							is visible to everyone, the minimum size for print and digital
							formats has to be respected.</p>
						</div>
					</div>
				</div>

				<div className="resume-section-content">
					<h6>Achromatic &amp; negative</h6>
					<div className="row">
						<div className="col-md-12">
							<div className="row">
								<div className="col-md-4">
									<div className="featurette-image img-fluide mx-auto">
										<img src="/img/chart/achromatic.png" width="250px" alt="Responsive image"/>
									</div>
								</div>
								<div className="col-md-4">
									<div className="featurette-image img-fluide mx-auto">
										<img src="/img/chart/poz-monochromatic.png" width="250px" alt="Responsive image"/>
									</div>
								</div>
								<div className="col-md-4">
									<div className="featurette-image img-fluide mx-auto">
										<img src="/img/chart/neg-monochromatic.png" width="250px" alt="Responsive image"/>
									</div>
								</div>
							</div>
							<p>Achromatic versions of the logo are allowed alternatively to the standard version.
							</p><p>The grayscale and the monochromatic versions have been specifically
							designed to meet some specific printing requirements.
							</p><p>Where technological limitations do not occur or where conceptual work does
							not say otherwise, the use of the standard version is recommended.</p>
						</div>
					</div>
				</div>

				<div className="resume-section-content resume-section-content-donts">
					<h6>Don&apos;ts</h6>
					<div className="row">
						<div className="col-md-12">
							<p>It is not allowed to alter the structure, colour, proportions, elements or
							the direction of the logo.
							</p><p>Further it is not allowed to add formulations like:</p>
							<ul>
								<li>with the support of</li>
								<li>sponsored by</li>
								<li>in the frame of</li>
								<li>etc.</li>
							</ul>

							<div className="row">
								<div className="col-md-4 centered">
									<div className="legend"><b><i className="far fa-times-circle"/> Don’t add shadows</b></div>
									<div className="featurette-image-donts img-fluide mx-auto">
										<img src="/img/chart/shadow.png" alt="Responsive image"/>
									</div>
								</div>
								<div className="col-md-4 centered">
									<div className="legend"><b><i className="far fa-times-circle"/> Don’t move elements</b></div>
									<div className="featurette-image-donts img-fluide mx-auto">
										<img src="/img/chart/move.png" alt="Responsive image"/>
									</div>
								</div>
								<div className="col-md-4 centered">
									<div className="legend"><b><i className="far fa-times-circle"/> Don’t stretch or transform</b></div>
									<div className="featurette-image-donts img-fluide mx-auto">
										<img src="/img/chart/stretch.png" alt="Responsive image"/>
									</div>
								</div>
							</div>
							<div className="row">
								<div className="col-md-4 centered">
									<div className="legend"><b><i className="far fa-times-circle"/> Don’t mix the colour versions</b></div>
									<div className="featurette-image-donts img-fluide mx-auto">
										<img src="/img/chart/mix.png" alt="Responsive image"/>
									</div>
								</div>
								<div className="col-md-4 centered">
									<div className="legend"><b><i className="far fa-times-circle"/> Don’t use the black version on a dark background</b></div>
									<div className="featurette-image-donts img-fluide mx-auto">
										<img src="/img/chart/black-dark.png" alt="Responsive image"/>
									</div>
								</div>
								<div className="col-md-4 centered">
									<div className="legend"><b><i className="far fa-times-circle"/> Don’t use the standard version on a dark-image background</b></div>
									<div className="featurette-image-donts img-fluide mx-auto">
										<img src="/img/chart/dark.png" alt="Responsive image"/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="resume-section-content">
					<h6>Colour codes</h6>
					<div className="row">
						<div className="col-md-12">
							<div className="row">
								<div className="col-sm-4">
									<div className="centered">
										<svg className="bd-placeholder-img rounded-circle" width="140" height="140" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img" aria-label="Placeholder: 140x140"><rect width="100%" height="100%" fill="#E30613"></rect></svg>
									</div>
									<ul>
										<li><span>CMYK</span> C0 M100 Y100 K0</li>
										<li><span>Pantone</span> 485
										</li><li><span>RGB</span> R 227 G 006 B 019
										</li><li><span>Hex</span> #E30613</li>
									</ul>
								</div>
								<div className="col-sm-4">
									<div className="centered">
										<svg className="bd-placeholder-img rounded-circle" width="140" height="140" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img" aria-label="Placeholder: 140x140"><rect width="100%" height="100%" fill="#0099FF"></rect></svg>
									</div>
									<ul>
										<li><span>CMYK</span> C100 M0 Y0 K0</li>
										<li><span>Pantone</span> Process Cyan
										</li><li><span>RGB</span> R 000 G 153 B 255
										</li><li><span>Hex</span> #0099FF</li>
									</ul>
								</div>
								<div className="col-sm-4">
									<div className="centered">
										<svg className="bd-placeholder-img rounded-circle" width="140" height="140" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img" aria-label="Placeholder: 140x140"><rect width="100%" height="100%" fill="#000"></rect></svg>
									</div>
									<ul>
										<li><span>CMYK</span> C0 M0 Y0 K100</li>
										<li><span>Pantone</span> Process Black
										</li><li><span>RGB</span> R 000 G 000 B 000
										</li><li><span>Hex</span> #000000</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="resume-section-content">
					<h6>The usage</h6>
					<div className="row">
						<div className="col-md-6 offset-md-3">
							<div className="featurette-image img-fluide mx-auto">
								<img src="/img/chart/cybersecurity-logo.jpg" width="400px" alt="Responsive image"/>
							</div>
						</div>
						<div className="col-md-12">
							<p>The standard logo may be used, in respect with the rules of these guidelines, by
							anyone to brand any publication, event, or any other activity in relation with
							cybersecurity and related to Luxembourg, either in Luxembourg or abroad.</p>
						</div>
					</div>
				</div>

				<div className="resume-section-content">
					<h6>Typeface</h6>
					<div className="row">
						<div className="col-md-12">
							<p>The primary typeface for any printing communication is Proxima Nova. Use the
							Regular weight for standard copy and the Bold weight for anything more
							important than that. For the main headings, we recommend the
							Proxima Nova Bold or Fjalla One.
						For the web, the Open Sans font is recommended.
						Fjalla One can also be used for headlines, quotes or to highlight important ideas for
						both printing and web communication.</p>
							<div className="featurette-image img-fluide mx-auto">
								<img src="/img/chart/typo.png" width="800px" className="img-fluid" alt="Responsive image"/>
							</div>
						</div>
					</div>
				</div>

				<div className="resume-section-content">
					<h6>Stationery</h6>
					<div className="row">
						<div className="col-md-8 offset-md-2">
							<div className="featurette-image img-fluide mx-auto">
								<img src="/img/chart/poster.png" width="800px" className="img-fluid" alt="Responsive image"/>
							</div>
							<div className="featurette-image img-fluide mx-auto">
								<img src="/img/chart/a4.png" width="600px" className="img-fluid" alt="Responsive image"/>
							</div>
							<div className="featurette-image img-fluide mx-auto">
								<img src="/img/chart/enveloppe-brochure.png" width="700px" className="img-fluid" alt="Responsive image"/>
							</div>
						</div>
					</div>
				</div>

				<div className="resume-section-content">
					<h6>Banners</h6>
					<div className="row">
						<div className="col-md-8 offset-md-2">
							<div className="featurette-image img-fluide mx-auto">
								<img src="/img/chart/banners.png" width="700px" className="img-fluid" alt="Responsive image"/>
							</div>
						</div>
					</div>
				</div>

				<div className="resume-section-content">
					<h6>Web</h6>
					<div className="row">
						<div className="col-md-8 offset-md-2">
							<div className="featurette-image img-fluide mx-auto">
								<img src="/img/chart/web.png" width="700px" className="img-fluid" alt="Responsive image"/>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
